import { render, staticRenderFns } from "./handhome.vue?vue&type=template&id=d27b796a"
import script from "./handhome.vue?vue&type=script&lang=js"
export * from "./handhome.vue?vue&type=script&lang=js"
import style0 from "./handhome.vue?vue&type=style&index=0&id=d27b796a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports